/**
 * Utility to optimize Scene7 image URLs and route them through
 * our local backend proxy to bypass aggressive client-side ad-blockers.
 */
export const optimizeImageUrl = (url, width = 800) => {
  if (!url || typeof url !== 'string' || !url.includes('scene7.com')) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);
    
    // Split the pathname by '/' and encode each segment properly.
    // decodeURIComponent throws on a literal '%' in a SKU; without the inner catch that
    // escaped to the outer one and returned the raw scene7 URL, silently un-proxying the
    // image for exactly the filenames most likely to need proxying.
    const pathSegments = parsedUrl.pathname.split('/').map(segment => {
      try {
        return encodeURIComponent(decodeURIComponent(segment));
      } catch {
        return encodeURIComponent(segment);
      }
    });
    
    parsedUrl.pathname = pathSegments.join('/');

    // Ensure it has performance parameters
    if (!parsedUrl.search) {
      parsedUrl.search = `?fmt=webp&wid=${width}`;
    }

    // Proxy the image request through our backend to bypass client-side trackers
    const optimizedExternalUrl = parsedUrl.toString();
    return `/api/proxy-image?url=${encodeURIComponent(optimizedExternalUrl)}`;
  } catch (e) {
    // Fallback if URL parsing fails
    return url;
  }
};
